"use client";



import { useEffect, useState } from "react";

import type { GamDisplaySize } from "@/components/ads/config";

import GamDisplaySlot from "./GamDisplaySlot";
import styles from "./MobileGamInlineAd.module.css";

type TargetingValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

type Props = {
  id: string;
  adUnit: string;
  sizes: ReadonlyArray<GamDisplaySize>;
  minHeight: number;
  placement: string;
  pageType: string;
  targeting?: Record<string, TargetingValue | null | undefined>;
  label?: "Sponsored" | "Advertisement";
};

const MOBILE_QUERY = "(max-width: 767px)";

export default function MobileGamInlineAd({
  id,
  adUnit,
  sizes,
  minHeight,
  placement,
  pageType,
  targeting,
  label = "Sponsored",
}: Props) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    const update = () => {
      setIsMobile(mediaQuery.matches);
    };

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  if (isMobile !== true || !adUnit) return null;

  return (
    <div className={styles.wrap} data-premium-mobile-ad={placement}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
      </div>

      <GamDisplaySlot
        id={id}
        adUnit={adUnit}
        sizes={[...sizes]}
        minHeight={minHeight}
        targeting={{
          page_type: pageType,
          device: "mobile",
          placement,
          ...targeting,
        }}
      />

      <div className={styles.footerSpacer} />
    </div>
  );
}